var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.912,
    viewBox: "6324 17379 20 16.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Favorites \\u2013 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3190"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3170"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 15629"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6334 17395.911c-.1 0-.2-.02-.295-.061-.098-.043-2.429-1.073-4.791-2.927-1.405-1.103-2.53-2.27-3.34-3.471-1.044-1.545-1.574-3.148-1.574-4.765 0-1.613.487-3.007 1.408-4.033.972-1.082 2.34-1.654 3.96-1.654 1.153 0 2.328.52 3.492 1.546.46.406.847.83 1.14 1.183.293-.354.68-.777 1.14-1.183 1.164-1.026 2.339-1.546 3.492-1.546 1.62 0 2.988.572 3.96 1.654.921 1.026 1.408 2.42 1.408 4.033 0 1.617-.53 3.22-1.574 4.765-.81 1.2-1.935 2.368-3.34 3.47-2.362 1.855-4.693 2.885-4.791 2.928a.737.737 0 0 1-.295.061Zm-4.632-15.44c-1.19 0-2.18.402-2.866 1.165-.674.752-1.031 1.807-1.031 3.05 0 5.266 6.993 8.936 8.529 9.678 1.534-.743 8.53-4.42 8.53-9.677 0-1.244-.357-2.3-1.032-3.05-.685-.764-1.676-1.167-2.866-1.167-1.967 0-3.765 2.52-3.964 2.806a.812.812 0 0 1-1.336 0c-.199-.287-1.998-2.806-3.964-2.806Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6334 17395.911c-.1 0-.2-.02-.295-.061-.098-.043-2.429-1.073-4.791-2.927-1.405-1.103-2.53-2.27-3.34-3.471-1.044-1.545-1.574-3.148-1.574-4.765 0-1.613.487-3.007 1.408-4.033.972-1.082 2.34-1.654 3.96-1.654 1.153 0 2.328.52 3.492 1.546.46.406.847.83 1.14 1.183.293-.354.68-.777 1.14-1.183 1.164-1.026 2.339-1.546 3.492-1.546 1.62 0 2.988.572 3.96 1.654.921 1.026 1.408 2.42 1.408 4.033 0 1.617-.53 3.22-1.574 4.765-.81 1.2-1.935 2.368-3.34 3.47-2.362 1.855-4.693 2.885-4.791 2.928a.737.737 0 0 1-.295.061Zm-4.632-15.44c-1.19 0-2.18.402-2.866 1.165-.674.752-1.031 1.807-1.031 3.05 0 5.266 6.993 8.936 8.529 9.678 1.534-.743 8.53-4.42 8.53-9.677 0-1.244-.357-2.3-1.032-3.05-.685-.764-1.676-1.167-2.866-1.167-1.967 0-3.765 2.52-3.964 2.806a.812.812 0 0 1-1.336 0c-.199-.287-1.998-2.806-3.964-2.806Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    stroke: "#000",
    fill: "transparent"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBlack);
export default __webpack_public_path__ + "static/media/heartBlack.77095871e6adab868ea9e3981ad54cc8.svg";
export { ForwardRef as ReactComponent };